import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  createIssueDetailsSlice,
  IssueDetailsSlice,
} from './storeSlices/issueDetails';
import {
  createIssueLocationSlice,
  IssueLocationSlice,
} from './storeSlices/issueLocation';
import {
  createYourDetailsSlice,
  YourDetailsSlice,
} from './storeSlices/yourDetails';

export const useCycleStore = create<
  YourDetailsSlice & IssueDetailsSlice & IssueLocationSlice
>()(
  persist(
    (...a) => ({
      ...createIssueDetailsSlice(...a),
      ...createIssueLocationSlice(...a),
      ...createYourDetailsSlice(...a),
    }),
    {
      name: 'report-it-cycle-hangars-storage', // name of the item in the storage (must be unique)
    },
  ),
);
